import { useMemo } from 'react';
import useAppStore from '../index';
import { DEFAULT_TEAM_BONUS } from '../types';
import { computeTeamBonusShares, normalizeTeamBonus } from '../selectors/teamBonusSelectors';

/** Fassade für Team-Leistungslohn — liest clientData.teamBonus, Actions aus dem Slice. */
export const useTeamBonus = () => {
    const clientData = useAppStore((s) => s.clientData);
    const setTeamBonusMode = useAppStore((s) => s.setTeamBonusMode);
    const setTeamBonusPoolAmount = useAppStore((s) => s.setTeamBonusPoolAmount);
    const toggleTeamBonusMember = useAppStore((s) => s.toggleTeamBonusMember);
    const setTeamBonusSelectedIds = useAppStore((s) => s.setTeamBonusSelectedIds);
    const applyTeamBonusShares = useAppStore((s) => s.applyTeamBonusShares);

    const computed = useMemo(() => computeTeamBonusShares(clientData || { personalData: [], unproductivePersonalData: [], azubiAssistenzData: [] }), [clientData]);

    const config = computed.config || DEFAULT_TEAM_BONUS;
    const isTeamMode = config.bonusMode === 'team';

    return {
        config,
        isTeamMode,
        bonusMode: config.bonusMode,
        poolAmount: config.poolAmount,
        selectedMemberIds: config.selectedMemberIds,
        rows: computed.rows,
        bonusById: computed.bonusById,
        sumSelectedGrundgehalt: computed.sumSelectedGrundgehalt,
        setBonusMode: setTeamBonusMode,
        setPoolAmount: setTeamBonusPoolAmount,
        toggleMember: toggleTeamBonusMember,
        setSelectedIds: setTeamBonusSelectedIds,
        applyShares: applyTeamBonusShares,
        normalize: normalizeTeamBonus,
    };
};

export default useTeamBonus;
